import { render, staticRenderFns } from "./AccountFrozen.vue?vue&type=template&id=9823a34a&scoped=true&"
import script from "./AccountFrozen.vue?vue&type=script&lang=js&"
export * from "./AccountFrozen.vue?vue&type=script&lang=js&"
import style0 from "./AccountFrozen.vue?vue&type=style&index=0&id=9823a34a&lang=less&scoped=true&"
import style1 from "./AccountFrozen.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9823a34a",
  null
  
)

export default component.exports